import React from 'react';
import { cn } from './cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => (
    <div className="ds-field">
      <input
        ref={ref}
        className={cn('ds-input', error ? 'ds-input--error' : '', className)}
        aria-invalid={!!error}
        {...props}
      />
      {error ? (
        <span role="alert" className="ds-text-muted" style={{ color: 'var(--ds-danger)' }}>
          {error}
        </span>
      ) : null}
    </div>
  )
);

Input.displayName = 'Input';
